var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3834_78387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.06992 10.6553L2.84953 8.43056C2.94886 8.14711 3.11075 7.88967 3.3232 7.67735L6.14687 4.854C6.34214 4.65876 6.65871 4.65877 6.85396 4.85402L9.14685 7.14691C9.34212 7.34218 9.34211 7.65878 9.14683 7.85404L6.32299 10.6776C6.11068 10.8897 5.85333 11.0514 5.57002 11.1506L3.34407 11.9299C2.55307 12.2068 1.79276 11.4462 2.06992 10.6553Z",
    fill: "#19A66B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1474 6.14744C10.3424 6.3425 10.6586 6.34273 10.854 6.14794L11.4261 5.57741C12.2076 4.79643 12.2078 3.52978 11.4265 2.74857L11.255 2.577C10.4741 1.79611 9.20807 1.79593 8.42696 2.57658L7.85498 3.14694C7.65925 3.34212 7.65902 3.65909 7.85448 3.85454L10.1474 6.14744Z",
    fill: "#19A66B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3834_78387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNotifications);
export default __webpack_public_path__ + "static/media/EditNotifications.8907a4222bf3ce42ba4b75803d226f12.svg";
export { ForwardRef as ReactComponent };